import React from "react";

// core components
import Button from "components/CustomButtons/Button.js";
import CancelIcon from "@material-ui/icons/Cancel";

//helper
import dayjs from "dayjs";
import { getTimeDifference } from "helpers/parseDates";
import { iconNoteType, iconServiceType } from "helpers/getIcon";
import { modals } from "helpers/dictionary";

// utils
import { ACCOUNT, NO_TIME } from "utils/variables";
import { ACTIVE, SERVICES } from "views/Map/MapPageTypes";
// Hooks
import { useClock } from "hooks/useClock";

// styles
import {
  ColumnStyled,
  ListItemStyled,
  ListItemTitleStyled,
  ListItemHeaderStyled,
  TitleContainerStyled,
  LineStyled,
  QuantityStyled,
  NameStyled,
} from "./styles";

const MapLateralMenuItem = ({
  item,
  isNote,
  unit,
  colorRGB,
  onOpen,
  onClose,
  selectedUnits,
  onOpenCancelModal,
}) => {
  const clock = useClock(60000);

  return (
    <React.Fragment>
      <ListItemStyled
        className={selectedUnits.includes(item.folio) ? "active-row-light" : ""}
        onClick={() =>
          !selectedUnits.includes(item.folio)
            ? onOpen(item.folio)
            : onClose(item.folio)
        }
      >
        <ColumnStyled width={18}>
          {!isNote ? (
            <img src={iconServiceType(item.account)} alt="" />
          ) : (
            <img
              src={
                unit.type
                  ? iconNoteType(unit.type, item.status)
                  : iconNoteType("")
              }
              alt=""
            />
          )}
        </ColumnStyled>
        <ColumnStyled dir="column" width={82} position="start">
          {!isNote ? (
            <>
              <ListItemHeaderStyled position="start">
                <ListItemTitleStyled left=".4" color={colorRGB}>
                  Cliente:
                </ListItemTitleStyled>
                <NameStyled>{item.customer}</NameStyled>
              </ListItemHeaderStyled>
              <ListItemHeaderStyled position="space-around">
                <TitleContainerStyled>
                  <ListItemTitleStyled color={colorRGB}>
                    Cuenta:
                  </ListItemTitleStyled>
                  <span>{item.account ? item.account : ACCOUNT}</span>
                </TitleContainerStyled>
                <TitleContainerStyled>
                  <ListItemTitleStyled color={colorRGB}>
                    Hr. Registro:
                  </ListItemTitleStyled>
                  <span>{item.a_hour}</span>
                </TitleContainerStyled>
                <TitleContainerStyled>
                  <ListItemTitleStyled color={colorRGB}>
                    Hr. Surtido:
                  </ListItemTitleStyled>
                  <span>{dayjs(item.hour, "HH:mm:ss").format("HH:mm")}</span>
                </TitleContainerStyled>
                <TitleContainerStyled>
                  <ListItemTitleStyled color={colorRGB}>
                    Diferencia:
                  </ListItemTitleStyled>
                  <span>
                    {" "}
                    {item.a_hour === NO_TIME
                      ? "N/A"
                      : getTimeDifference(
                          item.a_hour,
                          "HH:mm",
                          item.hour,
                          "HH:mm:ss"
                        )}
                  </span>
                </TitleContainerStyled>
              </ListItemHeaderStyled>
            </>
          ) : (
            <>
              <ListItemHeaderStyled position="space-between">
                <ListItemTitleStyled left=".4" color={colorRGB}>
                  Cliente:
                </ListItemTitleStyled>
                <NameStyled>{item.customer}</NameStyled>
                {item.status === ACTIVE && item.type === SERVICES && (
                  <Button
                    onClick={() => onOpenCancelModal(item, modals.cancel)}
                    justIcon
                    simple
                    round
                    color="danger"
                    size="sm"
                  >
                    <CancelIcon />
                  </Button>
                )}
              </ListItemHeaderStyled>
              <ListItemHeaderStyled position="space-around">
                <TitleContainerStyled>
                  <ListItemTitleStyled color={colorRGB}>
                    Cuenta:
                  </ListItemTitleStyled>
                  <span>{item.account ? item.account : ACCOUNT}</span>
                </TitleContainerStyled>
                <TitleContainerStyled>
                  <ListItemTitleStyled color={colorRGB}>
                    Hr. Registro:
                  </ListItemTitleStyled>
                  <span>{dayjs(item.hour, "HH:mm:ss").format("HH:mm")}</span>
                </TitleContainerStyled>
                <TitleContainerStyled>
                  <ListItemTitleStyled color={colorRGB}>
                    Hr. Actual:
                  </ListItemTitleStyled>
                  <span>{clock}</span>
                </TitleContainerStyled>
                <TitleContainerStyled>
                  <ListItemTitleStyled color={colorRGB}>
                    Diferencia:
                  </ListItemTitleStyled>
                  <span>
                    {" "}
                    {clock &&
                      getTimeDifference(item.hour, "HH:mm:ss", clock, "HH:mm")}
                  </span>
                </TitleContainerStyled>
              </ListItemHeaderStyled>
            </>
          )}

          {!isNote && (
            <>
              <LineStyled />
              <ListItemHeaderStyled position="start">
                <ListItemTitleStyled left=".4" color={colorRGB}>
                  Cantidad:
                </ListItemTitleStyled>
                <QuantityStyled>{item.quantity}</QuantityStyled>
              </ListItemHeaderStyled>
            </>
          )}
        </ColumnStyled>
      </ListItemStyled>
    </React.Fragment>
  );
};

export default React.memo(MapLateralMenuItem);
